import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { AppUtils } from "@app/shared/util/app.utils";
import { PagedResponse } from "@models/response.model";
import { ToolRequestHistory } from "@models/tool-request-history.model";
import { ToolReturnHistory } from "@models/tool-return-history.model";
import { map } from "rxjs/operators";

@Injectable()
export class RequestHistoryService {

    static readonly REQUEST_HISTORY_API_GET_PATH = `${environment.baseURL}/api/request/history/toolRequest`;
    static readonly REQUEST_HISTORY_API_DOWNLOAD_PATH = `${environment.baseURL}/api/request/history/toolRequest/download`;

    static readonly RETURN_HISTORY_API_GET_PATH = `${environment.baseURL}/api/request/history/toolReturn`;
    static readonly RETURN_HISTORY_API_DOWNLOAD_PATH = `${environment.baseURL}/api/request/history/toolReturn/download`;

    constructor(private http: HttpClient) {
    }

    getRequestHistory(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<ToolRequestHistory>>(RequestHistoryService.REQUEST_HISTORY_API_GET_PATH,
            {params: params}).pipe(map(this.mapRequestHistory));
    }

    private mapRequestHistory = res => {
        return {
            toolRequestHistory: res.items.map(toolRequestHistory => new ToolRequestHistory(toolRequestHistory)),
            count: res.total
        };
    };

    downloadRequestHistoryReport(requestConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(requestConfig);
        return this.http.get(RequestHistoryService.REQUEST_HISTORY_API_DOWNLOAD_PATH,
            {observe: 'response', params: params, responseType: 'blob'});
    }

    getReturnHistory(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<ToolReturnHistory>>(RequestHistoryService.RETURN_HISTORY_API_GET_PATH,
            {params: params}).pipe(map(this.mapReturnHistory));
    }

    private mapReturnHistory = res => {
        return {
            toolReturnHistory: res.items.map(toolReturnHistory => new ToolReturnHistory(toolReturnHistory)),
            count: res.total
        };
    };

    downloadReturnHistoryReport(requestConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(requestConfig);
        return this.http.get(RequestHistoryService.RETURN_HISTORY_API_DOWNLOAD_PATH,
            {observe: 'response', params: params, responseType: 'blob'});
    }
}
